var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActiveStep(_vm.step)
    ? _c(
        "StepWrapper",
        { attrs: { step: _vm.step } },
        [
          _vm.getPossibleResults.length > 0
            ? _c("decorfinder", {
                attrs: {
                  "base-products": _vm.getPossibleResults,
                  mode: "inline",
                },
                on: { change: _vm.onDecorSelection },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button-wrapper spacer--top-small spaced" },
            [
              _c(
                "GlobalButton",
                { attrs: { theme: "secondary" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("decor.button.back")))]
              ),
              _vm._v(" "),
              _c(
                "GlobalButton",
                {
                  attrs: { theme: "primary", disabled: !_vm.hasDecorSelection },
                  on: { click: _vm.next },
                },
                [_vm._v(_vm._s(_vm.$t("decor.button.next")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }